import { c as _c } from "react/compiler-runtime";
import { ArrowUpRight01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { NavigationMenuLink } from "@matsuricon/ui/navigation-menu";
import Link from "next/link";
import type { NavLeaf } from "./navigation-data";
import { isCurrentPath } from "./navigation-utils";
type DesktopLeafLinkProps = {
  item: NavLeaf;
  pathname: string;
};
export function DesktopLeafLink(t0) {
  const $ = _c(19);
  const {
    item,
    pathname
  } = t0;
  let t1;
  if ($[0] !== item.external || $[1] !== item.href || $[2] !== pathname) {
    t1 = !item.external && isCurrentPath(pathname, item.href);
    $[0] = item.external;
    $[1] = item.href;
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const current = t1;
  let t2;
  if ($[4] !== item.label) {
    t2 = <span className="min-w-0 flex-1">{item.label}</span>;
    $[4] = item.label;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== item.external) {
    t3 = item.external ? <><HugeiconsIcon aria-hidden="true" icon={ArrowUpRight01Icon} strokeWidth={1.8} /><span className="sr-only"> (external site)</span></> : null;
    $[6] = item.external;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const content = t4;
  let t5;
  if ($[11] !== content || $[12] !== current || $[13] !== item.external || $[14] !== item.href) {
    t5 = item.external ? <a aria-current={current ? "page" : undefined} href={item.href}>{content}</a> : <Link aria-current={current ? "page" : undefined} href={item.href}>{content}</Link>;
    $[11] = content;
    $[12] = current;
    $[13] = item.external;
    $[14] = item.href;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== current || $[17] !== t5) {
    t6 = <NavigationMenuLink active={current} asChild={true}>{t5}</NavigationMenuLink>;
    $[16] = current;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}